"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Company = void 0;
const tslib_1 = require("tslib");
const class_transformer_1 = require("class-transformer");
const typeorm_1 = require("typeorm");
const company_contact_entity_1 = require("./company-contact.entity");
const company_detail_entity_1 = require("./company-detail.entity");
const company_document_map_entity_1 = require("./company-document-map.entity");
const company_gst_detail_entity_1 = require("./company-gst-detail.entity");
const company_address_entity_1 = require("./company.address.entity");
const country_entity_1 = require("./country.entity");
const group_comapny_map_entity_1 = require("./group-comapny-map.entity");
const look_up_entity_1 = require("./look-up.entity");
const policy_entity_1 = require("./policy.entity");
const user_1 = require("./user");
const opportunity_entity_1 = require("./opportunity.entity");
const currency_entity_1 = require("./currency.entity");
let Company = class Company {
    constructor(companyName, displayName, companyTypeLid, currencyId, industrySegmentLid, noOfEmployees, website, dateOfIncorporation, panCardNumber, registrationNo, annualPremium, tanNumber, groupCompanyLid, priorityLid, statusLid, remarks, sentimentLid, sourceTypeLid, source, leadCrm, accountManager, countryId) {
        this.companyName = companyName;
        this.displayName = displayName;
        this.companyTypeLid = companyTypeLid;
        this.currencyId = currencyId;
        this.industrySegmentLid = industrySegmentLid;
        this.noOfEmployees = noOfEmployees;
        this.website = website;
        this.dateOfIncorporation = dateOfIncorporation;
        this.panCardNumber = panCardNumber;
        this.registrationNo = registrationNo;
        this.annualPremium = annualPremium;
        this.tanNumber = tanNumber;
        this.priorityLid = priorityLid;
        this.remarks = remarks;
        this.statusLid = statusLid;
        this.groupCompanyLid = groupCompanyLid;
        this.sentimentLid = sentimentLid;
        this.sourceTypeLid = sourceTypeLid;
        this.source = source;
        this.leadCrm = leadCrm;
        this.accountManager = accountManager;
        this.countryId = countryId;
    }
};
exports.Company = Company;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Company.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "company_name",
        type: "text",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", String)
], Company.prototype, "companyName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "display_name",
        type: "text",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", String)
], Company.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_type_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Company.prototype, "companyTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "currency_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Company.prototype, "currencyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "industry_segment_lid",
        type: "int",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", Number)
], Company.prototype, "industrySegmentLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "no_of_employees", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Company.prototype, "noOfEmployees", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "website", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], Company.prototype, "website", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "date_of_incorporation", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], Company.prototype, "dateOfIncorporation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "pan_card_number", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], Company.prototype, "panCardNumber", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "registration_no", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], Company.prototype, "registrationNo", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "annual_premium",
        type: "decimal",
        nullable: true,
        precision: 15,
        scale: 2,
    }),
    tslib_1.__metadata("design:type", Number)
], Company.prototype, "annualPremium", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "tan_number", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], Company.prototype, "tanNumber", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], Company.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        onUpdate: "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], Company.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], Company.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Company.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Company.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "priority_lid", type: "int", nullable: false }) // Add priority_lid
    ,
    tslib_1.__metadata("design:type", Number)
], Company.prototype, "priorityLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int", nullable: true }) // Add statusLid
    ,
    tslib_1.__metadata("design:type", Number)
], Company.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], Company.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "source_type_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Company.prototype, "sourceTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "source", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], Company.prototype, "source", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "group_company_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Company.prototype, "groupCompanyLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "lead_crm", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Company.prototype, "leadCrm", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "account_manager", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Company.prototype, "accountManager", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "country_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Company.prototype, "countryId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "sentiment_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Company.prototype, "sentimentLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "company_type_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_f = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _f : Object)
], Company.prototype, "companyType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => currency_entity_1.Currency),
    (0, typeorm_1.JoinColumn)({ name: "currency_id", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_g = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _g : Object)
], Company.prototype, "currency", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "industry_segment_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_h = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _h : Object)
], Company.prototype, "industrySegment", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "priority_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_j = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _j : Object)
], Company.prototype, "priority", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "status_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_k = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _k : Object)
], Company.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "group_company_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_l = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _l : Object)
], Company.prototype, "groupCompany", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => company_address_entity_1.CompanyAddress, (companyAddress) => companyAddress.company, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], Company.prototype, "companyAddresses", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => company_gst_detail_entity_1.StateGstDetail, (stateGstDetail) => stateGstDetail.company),
    tslib_1.__metadata("design:type", Array)
], Company.prototype, "stateGstDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => policy_entity_1.Policy, (policy) => policy.company),
    tslib_1.__metadata("design:type", Array)
], Company.prototype, "policies", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => company_document_map_entity_1.CompanyDocMap, (companyDocMap) => companyDocMap.company),
    tslib_1.__metadata("design:type", Array)
], Company.prototype, "companyDocMaps", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => group_comapny_map_entity_1.GroupCompanyMap, (groupCompanyMap) => groupCompanyMap.company
    // { cascade: true }
    ),
    tslib_1.__metadata("design:type", Array)
], Company.prototype, "groupCompanyMaps", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => company_detail_entity_1.CompanyDetail, (detail) => detail.company, {
        cascade: true,
        onDelete: "CASCADE",
        onUpdate: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "id", referencedColumnName: "companyId" }),
    tslib_1.__metadata("design:type", typeof (_m = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _m : Object)
], Company.prototype, "details", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => company_contact_entity_1.CompanyContactMap, (companyContact) => companyContact.company, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], Company.prototype, "companyContactMaps", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => user_1.User),
    (0, typeorm_1.JoinColumn)({ name: "lead_crm", referencedColumnName: "userId" }),
    tslib_1.__metadata("design:type", typeof (_o = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _o : Object)
], Company.prototype, "leadCrmInfo", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => user_1.User),
    (0, typeorm_1.JoinColumn)({ name: "account_manager", referencedColumnName: "userId" }),
    tslib_1.__metadata("design:type", typeof (_p = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _p : Object)
], Company.prototype, "accountManagerInfo", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "source_type_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_q = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _q : Object)
], Company.prototype, "sourceType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => country_entity_1.Country, { eager: true }),
    (0, typeorm_1.JoinColumn)({ name: "country_id", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_r = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _r : Object)
], Company.prototype, "country", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "sentiment_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_s = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _s : Object)
], Company.prototype, "sentiment", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.company, {
        cascade: false,
        onDelete: "CASCADE",
    }),
    tslib_1.__metadata("design:type", Array)
], Company.prototype, "opportunities", void 0);
exports.Company = Company = tslib_1.__decorate([
    (0, typeorm_1.Entity)("company"),
    tslib_1.__metadata("design:paramtypes", [String, String, Number, Number, Number, Number, String, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, String, String, Number, String, Number, Number, Number, String, Number, Number, String, Number, Number, Number])
], Company);
